import { ITravelProfileData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class TravelProfile {
  parrentType: string;
  isMemberLike: boolean;
  itemList: IContentItem[];
  seoURL?: string;

  constructor() {
    this.parrentType = '';
    this.isMemberLike = false;
    this.itemList = [];
    this.seoURL = '';
  }

  static mappingItem(_obj: ITravelProfileData): IContentItem {
    const obj: any = {};
    const { Owner, TravelProfileItem } = _obj;
    obj.parentType = _obj.ParentType ? _obj.ParentType : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.owner = Owner ? owner.mappingObject(Owner) : {};
    obj.travelProfileItem = {
      origin: {
        city: TravelProfileItem?.Origin?.City || '',
        state: TravelProfileItem?.Origin?.State || '',
        stateAbbr: TravelProfileItem?.Origin?.StateAbbr || '',
        country: TravelProfileItem?.Origin?.Country || '',
      },
      destination: {
        city: TravelProfileItem?.Destination?.City || '',
        state: TravelProfileItem?.Destination?.State || '',
        stateAbbr: TravelProfileItem?.Destination?.StateAbbr || '',
        country: TravelProfileItem?.Destination?.Country || '',
      },
      dateArrivedTick: TravelProfileItem?.DateArrivedTick || '',
      dateDepartureTick: TravelProfileItem?.DateDepartureTick || '',
    };
    return obj;
  }

  static mappingItemList(data: ITravelProfileData[]): IContentItem[] {
    return data.map(item => TravelProfile.mappingItem(item));
  }

  static mappingObject(_obj: ITravelProfileData): IContentItem {
    let obj = Object.assign(new TravelProfile(), _obj);
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.itemList = _obj.ItemList ? TravelProfile.mappingItemList(_obj.ItemList) : [];
    obj.seoURL = _obj.SEOUrl || '';
    obj = utils.cleanObjectKeys(Object.keys(new TravelProfile()), obj);

    return obj;
  }

  static mappingObjects(_data: ITravelProfileData[]): IContentItem[] {
    return _data.map(item => TravelProfile.mappingObject(item));
  }
}
